export default __webpack_public_path__ + "static/media/43t.599dd7c3.jpg";